var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#662BC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 347.429L132.444 353.143L156.444 384H346.49H355.556L384 347.429L312.889 256L379.556 170.286L384 164.571L355.556 128H156.444L151.912 133.828L128 164.571L199.111 256L128 347.429ZM213.752 329.143C207.794 329.143 204.442 322.289 208.1 317.586L227.556 292.571L256 329.143H213.752ZM308.356 250.172L370.49 170.286H255.373C251.649 170.286 249.554 174.569 251.84 177.509L256 182.857H298.248C304.206 182.857 307.558 189.711 303.9 194.414L284.444 219.429L308.356 250.172ZM137.065 164.571L277.109 344.627L278.114 345.92C280.401 348.859 278.306 353.143 274.581 353.143H270.222H141.51L161.065 378.286H342.046L156.444 139.656L137.065 164.571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdex);
export default __webpack_public_path__ + "static/media/IDEX.eba8fd532ef4cd8be68993e586ef6eac.svg";
export { ForwardRef as ReactComponent };